export default {
  copyrights: {
    en: `
      SCENTBIRD © {year}, All rights reserved.<br />
      Made with love in NYC.
    `,
  },
}
